module.exports = __webpack_public_path__ + "images/phone.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/phone.png
// module id = ./node_modules/file-loader/dist/cjs.js?name=images/[name].[ext]!./src/images/email/phone.png
// module chunks = 21